<template>
  <div class="content">
    <PageHeader title="RCS" :subtitle="$tc('app.report', 2)" />
    <div class="page-content container-fluid">
      <div class="row">
        <div class="col-lg-12 col-xl-12">
          <div class="card card-tabs">
            <div class="card-header">
              <ul class="nav nav-tabs">
                <li class="nav-item" role="presentation">
                  <router-link :to="{ name: 'RcsStatReport' }" class="nav-link" replace
                    ><span class="material-symbols-outlined"> query_stats </span>{{ $tc('app.stats', 2) }}</router-link
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <router-link :to="{ name: 'RcsHistoryReport' }" class="nav-link" replace
                    ><span class="material-symbols-outlined"> history </span>{{ $t('app.history') }}</router-link
                  >
                </li>
                <!--<li class="nav-item" role="presentation">
                  <router-link
                    :to="{ name: 'RcsUsageReport' }"
                    class="nav-link"
                    replace
                    ><span class="material-symbols-outlined">
                      insert_chart </span
                    >{{ $tc('app.usage', 1) }}</router-link
                  >
                </li>-->
                <li class="nav-item" role="presentation">
                  <router-link :to="{ name: 'RcsCampaignReport' }" class="nav-link" replace
                    ><span class="material-symbols-outlined"> campaign </span>{{ $tc('app.campaign', 2) }}</router-link
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <router-link :to="{ name: 'RcsReportExports' }" class="nav-link" replace
                    ><span class="material-symbols-outlined"> cloud_download </span>{{ $tc('app.file', 2) }}</router-link
                  >
                </li>
                <div class="opts_card">
                  <a style="display: flex; align-items: center" href="javascript:void(0)" @click="$refs.filter.toggle()"
                    ><span class="material-symbols-outlined title"> filter_list </span></a
                  >
                  <a style="display: flex; align-items: center" href="javascript:void(0)" @click="reload"><span class="material-symbols-outlined title"> refresh </span></a>
                  <form class="form-inline calendar_form">
                    <date-range-picker class="form-control" :format="'YYYY-MM-DD'" :options="options" @change="changeDate" />
                  </form>
                  <span class="material-icons title calendar_icon"> calendar_today </span>
                  <dropdown tag="span">
                    <template #text>
                      <i class="fas fa-file-export title"></i>
                    </template>
                    <template #items>
                      <a class="dropdown-item" href="javascript:void(0)" @click="exportData('csv')">CSV</a>
                      <a v-if="$route.name === 'RcsStatReport'" class="dropdown-item" href="javascript:void(0)" @click="exportData('png')">PNG</a>
                      <a v-if="$route.name === 'RcsStatReport'" class="dropdown-item" href="javascript:void(0)" @click="exportData('svg')">SVG</a>
                      <a v-if="$route.name !== 'RcsStatReport'" class="dropdown-item" href="javascript:void(0)" @click="exportData('xlsx')">XLSX</a>
                      <a v-if="$route.name !== 'RcsStatReport'" class="dropdown-item" href="javascript:void(0)" @click="exportData('pdf')">PDF</a>
                    </template>
                  </dropdown>
                </div>
              </ul>
            </div>
            <div class="card-body block-el">
              <router-view ref="view" @filter="changeCampaign" :filters="form.filters" :start-date="form.date.gte" :end-date="form.date.lte" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <SidebarComponent ref="filter" title="Filtros">
      <SelectComponent v-model="filter.agent_id" :label="$tc('app.agent', 1)" :options="agents" text-field="name" value-field="id" multiple></SelectComponent>
      <InputComponent :name="$t('app.recipient')" type="text" :label="$tc('app.recipient', 1)" placeholder="5511999999999" v-model="filter.to"></InputComponent>
      <SelectComponent v-model="filter.status" :label="$tc('app.status', 1)" :options="statusOptions" text-field="name" value-field="value" multiple></SelectComponent>
      <SelectComponent v-model="filter.campaign_id" :label="$tc('app.campaign', 2)" :options="campaigns" text-field="name" value-field="id"></SelectComponent>
      <template #footer>
        <div class="d-flex justify-content-between">
          <ButtonComponent @click="cleanFilter" variant="secondary">Limpar</ButtonComponent>
          <ButtonComponent @click="applyFilter">Aplicar Filtros</ButtonComponent>
        </div>
      </template>
    </SidebarComponent>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment';
import PageHeader from '@/components/rebranding/PageHeader.vue';
import Dropdown from '@/components/Dropdown';
import Tab from '@/directives/Tab';
import InputComponent from '@/components/form/InputComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import SidebarComponent from '@/components/SidebarComponent.vue';
import SelectComponent from '@/components/form/SelectComponent.vue';

export default {
  name: 'RcsDashboard',
  components: {
    PageHeader,
    Dropdown,
    SelectComponent,
    SidebarComponent,
    ButtonComponent,
    InputComponent,
    // Card,
  },
  directives: {
    Tab,
  },
  data() {
    return {
      filter: {
        carrier: [],
        status: [],
        from: '',
        to: '',
        segments: '',
        campaign_id: '',
      },
      statusOptions: [
        {
          name: 'Enviado',
          value: 'sent',
        },
        {
          name: 'Entregue',
          value: 'delivered',
        },
        {
          name: 'Lido',
          value: 'read',
        },
        {
          name: 'Falha',
          value: 'failed',
        },
      ],
      options: {
        timePicker: false,
        autoApply: true,
        className: 'form-control',
        startDate: moment().format('DD/MM/YYYY'),
        maxSpan: {
          days: 31,
        },
        locale: {
          format: 'DD/MM/YYYY',
          daysOfWeek: ['Do', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sa'],
          monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Otu', 'Nov', 'Dez'],
        },
      },
      form: {
        category: 'rcs',
        date: {
          gte: moment().startOf('day').format(),
          lte: moment().endOf('day').format(),
        },
        filters: {
          carrier: [],
          status: [],
          from: '',
          to: '',
          segments: '',
          campaign_id: '',
        },
      },
      campaigns: [],
    };
  },
  created() {
    this.fetchAgents();
    this.fetchCampaigns();
  },
  methods: {
    fetchAgents() {
      this.$store.dispatch('fetchRcsAgents').then((response) => {
        this.agents = response;
      });
    },
    showFilter() {
      this.$refs['filter-modal'].toggle();
    },
    reload() {
      this.$refs.view.fetch();
    },
    applyFilter() {
      this.form.filters = this.filter;
      this.$refs.filter.hide();
      this.$nextTick(() => {
        this.reload();
      });
    },
    changeCampaign(route, campaignId) {
      this.filter.campaign_id = campaignId;
      this.$router.push(route);
      this.applyFilter();
    },
    cleanFilter() {
      this.filter = {
        carrier: [],
        status: [],
        from: '',
        to: '',
        segments: '',
        campaign_id: '',
      };
      this.form.filter = {};
      this.reload();
    },
    changeDate(date) {
      if (date) {
        this.form.date.gte = moment(date[0]).startOf('day').format();
        this.form.date.lte = moment(date[1]).endOf('day').format();

        this.$nextTick(() => {
          this.reload();
        });
      }
    },
    exportData(format) {
      this.$refs.view.exportData(format);
    },
    fetchCampaigns() {
      this.$store.dispatch('fetchRcsCampaigns').then((response) => {
        this.campaigns = response;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~primevue/resources/themes/saga-blue/theme.css';
@import '~primevue/resources/primevue.min.css';

.table-responsive {
  min-height: 150px;
}

/* Rebranding */
.card.card-tabs .card-header .nav.nav-tabs {
  width: 100%;
  padding: 0 1rem;
  gap: 2.5rem;
}
.card.card-tabs .card-header .nav.nav-tabs li a {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 1.4rem 0.7rem 1.3rem;
  color: var(--clr-light-2);
}
.nav.nav-tabs .nav-item .nav-link.router-link-exact-active {
  color: var(--clr-yup-purple) !important;
  border-bottom: solid 2px var(--clr-yup-purple);
}

.nav.nav-tabs .nav-item .nav-link.router-link-exact-active i {
  color: var(--clr-yup-purple) !important;
}

.card.card-tabs .card-header .nav.nav-tabs li a i {
  font-size: 24px;
}

.nav-tabs .nav-item {
  margin-bottom: -2px;
}
.nav-tabs {
  border-bottom: 2px solid rgba(210, 221, 234, 0.5);
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.calendar_form {
  position: absolute;
  right: 70px;
  width: 38px;
  opacity: 0;
}

.calendar_form:hover ~ .calendar_icon,
.calendar_form:focus-within ~ .calendar_icon {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.calendar_form input {
  cursor: pointer;
  width: 38px;
}
</style>
